import shouldForwardProp from '@styled-system/should-forward-prop';
import styled from 'styled-components';

import type { Space } from '../../../theme/space';

export type Props = Readonly<{
  gap: Space;
  regular?: boolean;
}>;

const Rows = styled.div.withConfig({
  shouldForwardProp
})<Props>`
  display: grid;
  gap: ${({ gap, theme }) => theme.scTheme.space[gap]};
  grid-auto-flow: row;
  grid-auto-rows: ${({ regular = false }) => (regular ? '1fr' : 'auto')};
  grid-template-columns: 100%;
  list-style-type: none;
  width: 100%;
`;

export default Rows;
